export default {
  quests: (state) => state.quests,
  quests_pending: (state) => state.quests_pending
}
